import { useRouter } from 'next/router'
import { useEffect, useMemo } from 'react'

import { useTranslation } from '@flecto/translations'
import { getImageUrl, isInsideIframe } from '@flecto/utils'

import { PageProductList } from '../..'
import { useStoreCategories } from '../../hooks/useStoreCategories'
import { useStoreDetails } from '../../hooks/useStoreDetails'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'

export function PageCategory() {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-category' })
  const router = useRouter()
  const path = useStorePathBuilder()
  const store = useStoreDetails()
  const isIframe = isInsideIframe()
  const categories = useStoreCategories()
  const categoryId = String(router.query.categoryId ?? '')
  const category = useMemo(
    () => categories?.find((cat) => `${cat.id}` === `${categoryId}`),
    [categories, categoryId]
  )
  const title = category?.name
  const bgImage = getImageUrl(category?.thumbnail_url) || ''

  useEffect(() => {
    if (!category) {
      router.push(path(`${isIframe ? '/products' : '/'}`))
    }
  }, [])

  if (!category) {
    return
  }

  return (
    <PageProductList
      htmlTitle={t('html_title', {
        store: store?.name,
        category: category.name,
      })}
      htmlMetaDescription={t('html_meta_description', {
        category: category.name,
      })}
      htmlMetaOgTitle={t('html_meta_og_title', {
        category: category.name,
      })}
      htmlMetaOgDescription={t('html_meta_og_description', {
        store: store?.name,
      })}
      title={title}
      subtitle={''}
      withBackgroundImage={bgImage}
      withCategoriesFilter={false}
      withCategoriesNavigation
    />
  )
}
